import type { PackageStatus } from "~/utils/allocationPackageLifecycle"
import { DateFormatType, formatDate } from "~/utils/datetime"
import type { RangePackage } from "./types"

export const PACKAGE_STATUS_META: Record<
  PackageStatus,
  { label: string; variant: "green" | "blue" | "neutral" }
> = {
  active: { label: "Active", variant: "green" },
  upcoming: { label: "Upcoming", variant: "blue" },
  ended: { label: "Not active", variant: "neutral" },
  not_active: { label: "Not active", variant: "neutral" },
}

export const PACKAGE_TYPE_LABEL: Record<RangePackage["type"], string> = {
  seasonal: "Seasonal",
  noos: "NOOS",
}

export const isPackageOpen = (status: PackageStatus) => status === "active" || status === "upcoming"

export const formatPackageDate = (date: string) => formatDate(date, DateFormatType.FullDateShort)

export const packageWindowLabel = (startDate: string | null, cutoffDate: string | null) =>
  startDate === null || cutoffDate === null
    ? "Always open"
    : `${formatPackageDate(startDate)} to ${formatPackageDate(cutoffDate)}`
